import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=d1270f0a&scoped=true"
import script from "./InquiryList.vue?vue&type=script&lang=js"
export * from "./InquiryList.vue?vue&type=script&lang=js"
import style0 from "./InquiryList.vue?vue&type=style&index=0&id=d1270f0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1270f0a",
  null
  
)

export default component.exports